/**
 * @file navActions.js
 * @location src/store/reducers/navActions.js
 * @role 네비게이션·사용자 전환 액션 핸들러
 */

export const navActions = {
  // SET_NAV { nav, patch? }
  //   patch: 부가 UI state 자유 패치
  //   prevNav: 직전 페이지 기억(마이 페이지 「뒤로」 복귀용) — 같은 nav 재진입 시 갱신 안 함
  SET_NAV: (state, action) => ({
    ...state,
    activeNav: action.nav,
    prevNav: action.nav === state.activeNav ? state.prevNav : state.activeNav,
    ...(action.patch ? action.patch : {}),
  }),
  SET_USER: (state, action) => ({
    ...state,
    uid: action.id,
    activeNav: 'tasks',
    progTargetId: null,
    modalTask: false, modalProg: false,
    modalInviteMember: false, modalSettings: false,
    taskModalAee: null,
  }),
};
